import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Breadcrumbs, Typography, useMediaQuery } from "@mui/material";
import Link from "@shared/components/contents/link/Link";
import { CobaltIcon } from "@docaposte-agility/da-design-system-icons";
import { usePageVersion } from "@frontoffice/hooks/PageVersionHook";
const BreadcrumbItem = (props) => {
    const { item, ...others } = props;
    const isHome = !item.fullPath || item.fullPath === "/" || item.fullPath === "";
    return (_jsx(Link, { underline: "none", title: item.title, url: item.fullPath || "/", sx: {
            color: "inherit",
        }, ...others, children: _jsx(Typography, { variant: "subtitle2", color: "inherit", component: "p", children: isHome ? "Accueil" : item.title }) }));
};
const Breadcrumb = () => {
    const { currentPageVersion } = usePageVersion();
    const { breadcrumbs = [] } = currentPageVersion || {};
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    const parentPage = React.useMemo(() => {
        return (breadcrumbs &&
            breadcrumbs.length > 1 &&
            breadcrumbs[breadcrumbs.length - 2]);
    }, [breadcrumbs]);
    const isHome = !parentPage?.fullPath ||
        parentPage?.fullPath === "/" ||
        parentPage?.fullPath === "";
    if (!breadcrumbs || breadcrumbs.length === 0) {
        return null;
    }
    return isMobile ? (_jsx(Breadcrumbs, { "aria-label": "Fil d'ariane", children: _jsx(Link, { underline: "none", title: parentPage.title, url: parentPage.fullPath || "/", sx: {
                color: "inherit",
            }, children: _jsx(Typography, { variant: "subtitle2", color: "inherit", children: _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: "4px" }, children: [_jsx(CobaltIcon, { name: "chevron-left", style: { fontSize: 16 } }), isHome ? "Accueil" : parentPage.title] }) }) }) })) : (_jsx(Breadcrumbs, { separator: _jsx(CobaltIcon, { name: "chevron-right", style: { fontSize: 16, verticalAlign: "bottom" } }), maxItems: 3, itemsAfterCollapse: 2, "aria-label": "Fil d'ariane", children: breadcrumbs.map((breadcrumbItem, index) => index !== breadcrumbs.length - 1 ? (_jsx(BreadcrumbItem, { item: breadcrumbItem }, breadcrumbItem.pageId)) : (_jsx(Typography, { title: breadcrumbItem.title, variant: "subtitle2", component: "p", sx: {
                color: "inherit",
            }, children: breadcrumbItem.title }, breadcrumbItem.pageId))) }));
};
const BreadcrumbWrapper = () => {
    const { currentPageVersion } = usePageVersion();
    const { breadcrumbs = [] } = currentPageVersion || {};
    if (breadcrumbs.length === 0)
        return null;
    return _jsx(Breadcrumb, {});
};
export default BreadcrumbWrapper;
